// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"rJ-z","carouselContainer":"sJ-z"};